class TimelineComponent extends HTMLElement {
  #observer = null;
  #activeStep = null;

  connectedCallback() {
    const steps = this.querySelectorAll('[data-timeline-step]');
    if (steps.length === 0) return;

    this.#observer = new IntersectionObserver(this.#onIntersect, {
      rootMargin: '-45% 0px -45% 0px',
      threshold: 0,
    });
    steps.forEach((step) => this.#observer.observe(step));
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }

  #onIntersect = (entries) => {
    const activeEntry = entries.find((entry) => entry.isIntersecting);
    if (!activeEntry || !(activeEntry.target instanceof HTMLElement)) return;

    if (this.#activeStep === activeEntry.target) return;
    this.#activeStep?.classList.remove('is-active');
    activeEntry.target.classList.add('is-active');
    this.#activeStep = activeEntry.target;
  };
}

if (!customElements.get('timeline-component')) {
  customElements.define('timeline-component', TimelineComponent);
}
